// import React from 'react';
// import Title from '../Title';

// export default function Twitter() {
//     return (
//         <div className="twitter">
//             <div className="inside-container">
//                 <Title title="twitter" color="#e8f4dc" />
//                 <div className="twitter-center">
//                     <div className="twitter-texts">
//                         <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Maxime ea ducimus dolor dignissimos commodi dolorem odio illo ex itaque officiis sunt nemo aliquid, cupiditate incidunt excepturi asperiores nobis! Aspernatur, cupiditate.</p>
//                     </div>
//                     <div className="twitter-icon">
//                         <i className="fab fa-twitter"></i>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }
import React from 'react';
import Title from '../Title';

export default function Testimonials2() {
	return (
		<div className="testimonial">
			<div className="inside-container">
				<Title title="testimonial..." color="#000000" />
				<div className="testimonial-center">
					<div className="testimonial-texts">
						<p>Moving aroud the area searching for places to have fun coz i just moved in to the area and noticed this place. The bar services was superb i even brought my friends afterwards and they all enjoyed hanging out here…… Nice one cvilla</p>
						<blockquote className="quotation">
							"Iskilu Rasheed Akanni (Web Developer and Graphics Designer)"
						</blockquote>
					</div>
					<div className="testimonial-icon">
						<i className="fas fa-quote-right"></i>
					</div>
				</div>
			</div>
		</div>
	)
}
